import React, { useState, useEffect } from 'react'
import { flowRight as compose, isEmpty } from 'lodash'
import qs from 'querystring'
import type { RouteChildrenProps } from 'react-router-dom'

import { withBackOfficeCms } from 'helpers/hocs'
import { routes } from 'helpers/routes'
import { addSearchParams } from 'helpers/common'
import { LIMIT_PAGE } from 'helpers/constants'
import { useBreadcrumbs } from 'helpers/hooks'
import {
  StaffSearchAndFilter,
  StaffList,
  StaffSingle,
  StaffPagination,
  useFindAll,
  HEADERS,
  BREADCRUMBS_LIST,
} from 'features/Staff'

import type { ISorting, ISetSearchParams, IParamStaff } from 'features/Staff'

const StaffContainer: React.FC<RouteChildrenProps> = ({
  history,
  location,
}: RouteChildrenProps) => {
  const base = 'con-staff'
  const { search, pathname } = location
  const searchParams: IParamStaff = qs.parse(search.replace('?', ''))

  const [{ data: staffs, loading, response }] = useFindAll(searchParams)
  const [totalPage, setTotalPages] = useState<number>(0)

  const setSearchParams: ISetSearchParams = (params) => {
    const nextParams = addSearchParams(searchParams, params)

    history.replace({
      pathname,
      search: qs.stringify(nextParams),
    })
  }

  const onSortChange = (sort: ISorting): void =>
    setSearchParams({ _sort: sort.column, _order: sort.order })

  useBreadcrumbs(BREADCRUMBS_LIST)

  useEffect(() => {
    const totals = response?.headers['x-total-count'] as string

    setTotalPages(Math.ceil(Number(totals) / LIMIT_PAGE) || 1)
  }, [staffs])

  const onRowClick = (id: string) => {
    history.push(`${routes.staff.path}/${id}/edit`)
  }

  return (
    <div className={base}>
      <StaffSearchAndFilter />
      <StaffList
        isUnSelectable
        onSortChange={onSortChange}
        sorting={{ column: searchParams._sort, order: searchParams._order }}
        isEmpty={isEmpty(staffs)}
        isLoading={loading}
        render={() =>
          staffs?.map((staff, index) => (
            <StaffSingle
              key={index}
              data={staff}
              onRowClick={onRowClick}
              columns={HEADERS}
            />
          ))
        }
      />
      <StaffPagination totalPage={totalPage} loading={loading} />
    </div>
  )
}

export default compose(withBackOfficeCms)(StaffContainer)
